import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {dwhDebtListPageReport, DwhActionType, DWHMessageText, DWHStatus} from './reports/dwhReports';
import {
  handleCurrentStep,
  endProccess,
  setBitPaymentOption,
  setPaymentFloors,
  setPaymentData,
  creditCardPay,
  submitCCPaymentMethod,
  getDebts,
  setIsJetConnection,
  logout,
  setEpiData,
  saveToHistory,
  setShowPopup,
} from './DebtAndUpdatePaymentBlockSlice';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import Config from 'app/Config';
import {cgTypeEnum} from '../../../utilities/enums/cgTypeEnum';
import {stepEnum, shouldUseBottomButtonLayout, backButtonVisibleSteps, paymentAction} from './Constants/debtPaymentEnum';
import loginSubTypes from '../../../constans/loginSubTypes';
import {deptPaymentDataToUpdate} from '../UpdatePaymentMethodBlock/updatePaymentMethodSlice';
import {resetBlock as resetBitBlock} from 'app/Components/Shared/BitPayment/bitPaymentSlice';
import {resetStore} from '../SaleBlock/Payment/PaymentSlice';
import {resetStore as resetCGStore} from '../SaleBlock/PaymentCG/PaymentCGSlice';
import PopUp from 'app/Components/Shared/Popup/PopUp';
import PopupWrapper from './SharedComponents/Popups/PopupWrapper';
import BitResultComponent from './Steps/BitResultComponent';

import NoAccounts from './Steps/NoAccounts';
import SelectPaymentBan from './Steps/SelectPaymentBan';
import SelectAmount from './Steps/SelectAmount';
import DebtPaymentError from './Steps/DebtPaymentError';
import GeneralMessage from './Steps/GeneralMessage';
import CreditCard from './Steps/CreditCard';
import DebtPaymentSuccess from './Steps/DebtPaymentSuccess';
import SelectPaymentOption from './Steps/SelectPaymentOption';
import SelectOptionForUpdatePayment from './Steps/SelectOptionForUpdatePayment';
import BankBranchSelection from './Steps/BankBranchSelection';
import BankFormSignature from './Steps/BankFormSignature';
import SelectUpdatePaymentBan from './Steps/SelectUpdatePaymentBan';
import UpdatePaymentSuccess from './Steps/UpdatePaymentSuccess';
import DebtPaymentStepper from './SharedComponents/DebtPaymentStepper';
import BackButtonComponent from './SharedComponents/BackButtonComponent';
import SendSmsEntityPayment from './Steps/SendSmsEntityPayment';
import SendSmsEntityPaymentSuccess from './Steps/SendSmsEntityPaymentSuccess';

import './debtPayment.scss';

const DebtPayment = (props) => {
  let state = props.state;

  const startProcess = async ({bitEvent, selectedAmount, selectedBan, externalSystemReference}) => {
    await props.getDebts({
      bitEvent,
      selectedAmount,
      selectedBan,
      externalSystemReference,
    });
  };

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });

        // const timeoutId = setTimeout(() => {
        if (state.currentStep !== stepEnum.INITIAL && !props.isLoading) {
          props.saveToHistory(state.currentStep);
        }
        //}, 1500);

        // return () => clearTimeout(timeoutId); // Cleanup on unmount or dependency change
      }
    },

    [state.currentStep, props.isLoading],
  );

  // Start process on component mount - check for bit payment URL parameters
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      setContentData();
      const externalSystemReferenceRegex = /externalSystemReference=([^&]+)/;
      const banRegex = /ban=([^&]+)/;
      const amountRegex = /amount=([^&]+)/;

      const location = window.location.search;
      const query = new URLSearchParams(location);
      let externalSystemReference, selectedBan, selectedAmount;
      let bitEvent = false;
      const paymentData = query.get('paymentData');

      if (paymentData) {
        bitEvent = true;
        const decodedString = atob(paymentData);
        externalSystemReference = decodedString.match(externalSystemReferenceRegex)[1];
        selectedBan = decodedString.match(banRegex)[1];
        selectedAmount = decodedString.match(amountRegex)[1];
      }

      startProcess({
        bitEvent,
        selectedAmount,
        selectedBan,
        externalSystemReference,
      });
      return () => {
        cleanStore();
      };
    }
  }, []);

  useEffect(() => {
    //JET
    if (props.authentication?.userDetails?.Impersonate && props.authentication?.userDetails?.loginSubType == loginSubTypes.ONBEHALF) {
      props.setIsJetConnection(props.authentication.userDetails.Ban);
    }
  }, [props.authentication.userDetails]);

  useEffect(() => {
    if (state.paymentData.pay && props.paymentCG.CCError !== true && props.paymentCG.CGData?.ccToken) {
      let generalObject = {};
      if (state.paymentAction !== paymentAction.UPDATE_PAYMENT_METHOD) {
        generalObject = {
          Account: props.state.selectedBanData.banNumber,
          AccountList: props.state.selectedBansForPaymentUpdate,
          Amount: props.state.paymentAmount,
          PaymentNo: !props.paymentCG.paymentCount || props.paymentCG.paymentCount === '' ? '1' : props.paymentCG.paymentCount,
          IsEnergy: props.state.selectedBanData.isEnergy,
          TerminalNumber: cgTypeEnum.DEBTPAYMENT,
        };
      } else {
        generalObject = {
          Account: props.state.selectedBanData.banNumber,
          AccountList: props.state.selectedBansForPaymentUpdate,
        };
      }

      const completPaymentData = getCGDataForCreditCard(generalObject);
      props.setPaymentData(completPaymentData);
      props.resetStore();
      if (state.paymentAction !== paymentAction.UPDATE_PAYMENT_METHOD) {
        props.creditCardPay(completPaymentData);
      } else {
        props.submitCCPaymentMethod(completPaymentData);
      }
    }
  }, [props.paymentCG.CCData.CCToken, state.paymentData.pay]);

  const cleanStore = () => {
    props.endProccess();
    props.resetStore();
    props.resetCGStore();
    props.resetBitBlock();
  };

  const setContentData = () => {
    props.setPaymentFloors({
      firstFloorAmount: props.contentData?.firstPaymentFloor?.value,
      secondFloorAmount: props.contentData?.secondPaymentFloor?.value,
      thirdFloorAmount: props.contentData?.thirdPaymentFloor?.value,
      firstFloorPayments: props.contentData?.firstPaymentFloorPayments?.value,
      secondFloorPayments: props.contentData?.secondPaymentFloorPayments?.value,
      thirdFloorPayments: props.contentData?.thirdPaymentFloorPayments?.value,
      fourthFloorPayments: props.contentData?.fourthPaymentFloorPayments?.value,
      maxPayment: props.contentData?.maxPaymentAmount?.value,
      maxPaymentEnergy: props.contentData?.maxPaymentAmountEnergy?.value,
      paymentStatusDisplayDaysX: props.contentData?.paymentStatusDisplayDaysX?.value,
      paymentStatusDisplayDaysY: props.contentData?.paymentStatusDisplayDaysY?.value,
      energyPaymentStatusDisplayDaysX: props.contentData?.energyPaymentStatusDisplayDaysX?.value,
      energyPaymentStatusDisplayDaysY: props.contentData?.energyPaymentStatusDisplayDaysY?.value,
    });

    props.setBitPaymentOption(props.contentData?.bitPaymentOption?.value);

    props.setEpiData({
      noDebtImageMobile: props.contentData?.noDebtImageMobile?.value?.url,
      noDebtImageDesktop: props.contentData?.noDebtImageDesktop?.value?.url,
      noAccountsFoundImageMobile: props.contentData?.noAccountsFoundImageMobile?.value?.url,
      noAccountsFoundImageDesktop: props.contentData?.noAccountsFoundImageDesktop?.value?.url,
      otherStatesImageMobile: props.contentData?.otherStatesImageMobile?.value?.url,
      otherStatesImageDesktop: props.contentData?.otherStatesImageDesktop?.value?.url,
      payingEntityLink: props.contentData?.showPayingEntityLink?.value,
      serviceTermsLink: props.contentData?.serviceTermsLink?.value,
      generalTitle: props.contentData.generalTitle.value,
      thereIsDebtSubTitle: props.contentData.thereIsDebtSubTitle.value,
      noDebtThereIsPaymentIssueSubTitle: props.contentData.noDebtThereIsPaymentIssueSubTitle.value,
      lastPaymentTypeValidation: props.contentData.lastPaymentTypeValidation.value,
      updatePaymentFailedSubTitle: props.contentData.updatePaymentFailedSubTitle?.value,
      iconBankSignatureWarning: props.contentData.iconBankSignatureWarning?.value?.url,
    });
  };

  const getCGDataForCreditCard = (generalObject) => {
    return {
      ...generalObject,
      IdNumber: props.paymentCG.CGData.id,
      CCToken: props.paymentCG.CGData.ccToken,
      CardYear: props.paymentCG.CGData.cardYear,
      CardMonth: props.paymentCG.CGData.cardMonth,
      AuthNo: props.paymentCG.CGData.authNumber,
      CreditCardType: props.paymentCG.CGData.ccType,
      CCFourLastNumbers: props.paymentCG.CGData.credit4Digits?.slice(-4) ?? '',
      IsDebit: props.paymentCG.CGData.isDebit,
    };
  };

  const redirectToLobby = () => {
    props.context.navigateTo(Config.lobbyUrl);
  };
  useEffect(() => {
    if (state.currentStep === stepEnum.INITIAL) return;
    const loginData = props.authentication;
    const groupedBans = state.groupedBans;
    const yDaysCount = props.yDaysCount;
    const yDaysCountEnergy = props.yDaysCountEnergy;
    if (state.currentStep === stepEnum.BANSELECT) {
      dwhDebtListPageReport({
        groupedBans,
        loginData,
        actionType: DwhActionType.AccountListPage,
        messageText: DWHMessageText.AccountListPageDisplayed,
        status: DWHStatus.Ongoing,
        yDaysCount,
        yDaysCountEnergy,
      });
    } else if (state.currentStep === stepEnum.NOACCOUNTS) {
      dwhDebtListPageReport({
        groupedBans,
        loginData,
        actionType: DwhActionType.AccountListPage,
        messageText: DWHMessageText.NoAccountExists,
        status: DWHStatus.Completed,
        yDaysCount,
        yDaysCountEnergy,
      });
    } else if (state.currentStep === stepEnum.GENERALERROR) {
      dwhDebtListPageReport({
        groupedBans,
        loginData,
        actionType: DwhActionType.AccountListPage,
        messageText: DWHMessageText.GeneralError,
        status: DWHStatus.Error,
        yDaysCount,
        yDaysCountEnergy,
      });
    }
  }, [state.currentStep]);

  useClearStateResetFlag();

  const endClick = async () => {
    await cleanStore();
    await setContentData();
    await startProcess(false);
  };

  const renderCurrentStep = () => {
    const currentStep = state.currentStep;

    // Render steps
    switch (currentStep) {
      case stepEnum.NOACCOUNTS:
        return <NoAccounts />;
      case stepEnum.BANSELECT:
        return <SelectPaymentBan />;
      case stepEnum.SELECTAMOUNT:
        return <SelectAmount />;

      case stepEnum.SELECTPAYMENTTYPE:
        return <SelectPaymentOption />;

      case stepEnum.SELECTUPDATEPAYMENTTYPE:
        return <SelectOptionForUpdatePayment />;

      case stepEnum.SELECTUPDATEPAYMENTBAN:
        return <SelectUpdatePaymentBan />;

      case stepEnum.CREDITCARD:
        return <CreditCard />;
      case stepEnum.PAYMENTSUCCESS:
        return <DebtPaymentSuccess onclick={endClick} goToLobby={redirectToLobby} />;

      case stepEnum.PAYMENTFAILED:
      case stepEnum.CREDITPAYMENTERROR:
        return <DebtPaymentError />;

      case stepEnum.GENERALERROR:
      case stepEnum.PAYMENTFAILEDENERGY:
      case stepEnum.CREDITPAYMENTERRORENERGY:
      case stepEnum.PAYMENTFAILEDWITHOUTBITOPTION:
      case stepEnum.UPDATEPAYMENTFAILEDBANK:
      case stepEnum.UPDATEPAYMENTFAILEDCC:
        return <GeneralMessage goToLobby={redirectToLobby} currentStep={currentStep} />;

      case stepEnum.BITGENERALERROR:
      case stepEnum.BITPAYMENTFAILED:
      case stepEnum.BITPAYMENTIMPOSSIBLE:
      case stepEnum.INCORRECTUSER:
      case stepEnum.BITPENDING:
        return <BitResultComponent redirectToLobby={redirectToLobby} logout={props.logout} />;
      //update payment steps
      case stepEnum.BANKRANCHSELECTION:
        return <BankBranchSelection />;
      case stepEnum.BANKFORMSIGNATURE:
        return <BankFormSignature />;
      case stepEnum.UPDATEPAYMENTSUCCESS:
        return <UpdatePaymentSuccess onclick={endClick} />;
      case stepEnum.SENDSMSENTITYPAYMENT:
        return <SendSmsEntityPayment />;
      case stepEnum.SENDSMSENTITYPAYMENTSUCCESS:
        return <SendSmsEntityPaymentSuccess phoneNumber={state.entityPaymentPhoneNumber} />;
      default:
        return null;
    }
  };

  const render = () => {
    const isPaymentErrorLayout = state.currentStep === stepEnum.PAYMENTFAILED || state.currentStep === stepEnum.CREDITPAYMENTERROR;

    return (
      <div className={`debt-update-payment-block ${shouldUseBottomButtonLayout(state.currentStep) ? ' bottom-button-step' : ''}`}>
        <BackButtonComponent />
        {state.paymentAction !== paymentAction.UPDATE_PAYMENT_METHOD && <DebtPaymentStepper currentStep={state.currentStep} />}
        <div
          className={`debtpayment-content ${backButtonVisibleSteps.includes(state.currentStep) ? ' back-button-visible' : ''} ${
            isPaymentErrorLayout ? 'payment-error-layout' : ''
          }`}>
          {renderCurrentStep()}
        </div>
        <PopUp
          className={`debt-payment-popup-container ${state.popupType}`}
          showPopUp={state.showPopUp}
          onClose={() => props.setShowPopup({showPopUp: false, mainCloseButton: true})}>
          <PopupWrapper />
        </PopUp>
      </div>
    );
  };

  return render();
};

const mapStateToProps = (state) => {
  return {
    state: state.debtAndUpdatePayment,
    paymentCG: state.PaymentCG,
    idNumber: state.authentication.loginData.userDetails.IDNumber,
    contactNumber: state.authentication.loginData.userDetails.contactNumber,
    authentication: state.authentication.loginData,
    yDaysCount: state.debtAndUpdatePayment.paymentStatusDisplayDaysY,
    yDaysCountEnergy: state.debtAndUpdatePayment.energyPaymentStatusDisplayDaysY,
    isLoading: state.loader.isLoading,
  };
};

const mapDispatchToProps = {
  handleCurrentStep,
  resetStore,
  resetCGStore,
  setPaymentData,
  endProccess,
  setBitPaymentOption,
  setPaymentFloors,
  deptPaymentDataToUpdate,
  creditCardPay,
  submitCCPaymentMethod,
  getDebts,
  setIsJetConnection,
  resetBitBlock,
  logout,
  setEpiData,
  saveToHistory,
  setShowPopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(DebtPayment);
